module.exports = __webpack_public_path__ + "img/JiHoROI.f76254d8.webp";